import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {SessionQuery} from "../services/session/session.query";

@Injectable({
  providedIn: 'root'
})
export class PraticableGuard implements CanActivate {

  constructor(private sessionQuery: SessionQuery, private router: Router) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const praticable = this.sessionQuery.getValue().user?.is_praticable;
    if (praticable) {
      return true;
    } else {
      this.router.navigateByUrl('');
      return false;
    }
  }

}
